import { render, staticRenderFns } from "./FormAgregado.vue?vue&type=template&id=22782322&scoped=true&"
import script from "./FormAgregado.vue?vue&type=script&lang=js&"
export * from "./FormAgregado.vue?vue&type=script&lang=js&"
import style0 from "./FormAgregado.vue?vue&type=style&index=0&id=22782322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22782322",
  null
  
)

export default component.exports